import { OK } from 'http-status-codes';
import resource from './resource';

export function getPeriodValidation(period) {
  return resource.getPeriodValidation(period)
    .then(response => response.status === OK)
    .catch(() => false);
}
